import $ from "jquery";

import Swiper, { Pagination, Autoplay } from 'swiper';

const sliders = document.querySelectorAll( '.js-partners-slider' );
sliders.forEach(slider => {
  const partnersSlider = new Swiper(slider, {
    modules: [Pagination, Autoplay],
    speed: 1200,
    loop: true,
    slidesPerView: 'auto',
    spaceBetween: 23,
    autoplay: {
      delay: 1000,
      disableOnInteraction: false,
    },
  });

  $(".js-partners-slider").mouseenter(function(){
    partnersSlider.autoplay.stop();
  });

  $(".js-partners-slider").mouseleave(function(){
    partnersSlider.autoplay.start();
  });
});
